import { observer } from 'mobx-react-lite';
import ReactDOM from 'react-dom';
import { forwardRef } from 'react';
import { useStore } from '../../stores/store';
import {
  BottomSidebarContainer,
  Container,
  Content,
} from './bottom-sidebar.styles';
import { BlurredBackground } from '../blurred-background/blurred-background.styles';
import CloseButton from '../close-button/close-button.component';
import { SidebarName } from '../../types/sidebar.types';
import { useCloseOnEscape } from '../../hooks/use-close-on-escape.hook';

interface Props {
  name: SidebarName;
  height?: string;
  children: any;
  withBlurredBackground?: boolean;
  onClose?: () => void;
  backgroundColor?: string;
  mobPadding?: string;
}

const BottomSidebar = (
  {
    name,
    children,
    height,
    withBlurredBackground,
    onClose,
    backgroundColor,
    mobPadding,
  }: Props,
  ref: React.Ref<HTMLDivElement>
) => {
  const {
    navStore: {
      isSidebarOpenedByName,
      isSidebarClosingByName,
      closeSidebarByName,
    },
  } = useStore();

  const handleClose = () => {
    if (!isSidebarOpenedByName(name) && !isSidebarClosingByName(name)) return;

    closeSidebarByName(name);
    onClose && onClose();
  };

  useCloseOnEscape(handleClose);

  if (!isSidebarOpenedByName(name) && !isSidebarClosingByName(name))
    return null;

  return ReactDOM.createPortal(
    <Container onClick={(e) => e.stopPropagation()}>
      <Content
        $height={height}
        $isOpened={isSidebarOpenedByName(name)}>
        <CloseButton
          onClick={(event) => {
            event.stopPropagation();
            handleClose();
          }}
        />
        <BottomSidebarContainer
          ref={ref}
          $height={height}
          $backgroundColor={backgroundColor}
          $mobPadding={mobPadding}>
          {children}
        </BottomSidebarContainer>
      </Content>
      {withBlurredBackground && <BlurredBackground />}
    </Container>,
    document.querySelector('#dropdown-root')!
  );
};

export default observer(forwardRef(BottomSidebar));
